import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertFormComponent from './advertForm.component';

let advertFormModule = angular.module('advertForm', [
  uiRouter
])

.component('advertForm', advertFormComponent)

.name;

export default advertFormModule;
